module.exports = __webpack_public_path__ + "static/media/instagramcontorno.89c61bd5.svg";